import { theme } from "@op-str/op-component-library"
import styled from "styled-components"

export const ExtraLargeLargeVerticalSpace = styled.div`
  height: ${parseInt(theme.spacing.xl) + parseInt(theme.spacing.l)}px;
`
